import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { type FC, type ReactElement } from "react";
import { useTranslation } from "react-i18next";
interface loader {
  mask: boolean;
  message?: string;
}
interface inlineerror {
  text?: string;
}
interface inlineLoader extends inlineerror {
  padding?: boolean;
}
export const Loader: FC<loader> = ({ message, mask }): ReactElement => {
  const { t } = useTranslation();
  return (
    <div data-testid="loader">
      {mask && <div className="mask" />}
      <div className="loader-wrapper">
        <div className="loader-container">
          <div className="loader" />
          {Boolean(message) && (
            <div className="loader-text">{t(message ?? "Loading ...")}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export const InlineErrorMessage: FC<inlineerror> = ({ text }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        textAlign: "center",
        paddingTop: "150px",
        fontStyle: "oblique",
        fontSize: "16px",
        color: "#acb4b7",
        fontFamily: "cursive",
      }}
    >
      <p>
        <InfoCircleOutlined style={{ fontSize: 34, color: "#acb4b7" }} />
      </p>
      {t(text ?? "Error occured while processing your request. Please retry.")}
    </div>
  );
};

export const InlineLoader: FC<inlineLoader> = ({ padding, text }) => {
  const { t } = useTranslation();
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#a3dfa5" }} spin />
  );
  return (
    <div
      style={{
        textAlign: "center",
        paddingTop: !(padding ?? false) ? "" : "150px",
        fontStyle: "oblique",
        fontSize: "16px",
        color: "#747778",
        fontFamily: "cursive",
      }}
    >
      {/* this was wrapped in a 'dispatchEvent` tag */}
      <Spin indicator={antIcon} />
      {t(text ?? "Loading data...")}
    </div>
  );
};
